import React, { useEffect, useState } from "react";
import { CheckCircle, Trash2, Star, Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ReviewsAdmin() {
  const [reviews, setReviews] = useState([]);

  const load = () => api.get("/reviews").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (id, key, value) => {
    await api.put(`/reviews/${id}`, null, { params: { [key]: value } });
    toast.success("Updated");
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Delete review?")) return;
    await api.delete(`/reviews/${id}`);
    load();
  };

  return (
    <div data-testid="reviews-admin">
      <h1 className="font-serif-display text-4xl text-gold-gradient mb-2">Reviews</h1>
      <p className="text-sm text-[#D1C7C9] mb-6">Moderate guest reviews. Only approved reviews appear on the public site.</p>

      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} className="bg-[#1A1A1A] border border-[#333] rounded-xl p-5" data-testid={`admin-review-${r.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-2">
                  <p className="font-medium">{r.name}</p>
                  <div className="flex gap-0.5">
                    {[...Array(r.rating)].map((_, k) => <Star key={k} size={12} className="text-[#D4AF37]" fill="currentColor" />)}
                  </div>
                  {r.is_approved && <span className="text-[10px] uppercase tracking-widest text-green-400 border border-green-400/40 px-2 py-0.5 rounded">Approved</span>}
                  {!r.is_approved && <span className="text-[10px] uppercase tracking-widest text-yellow-400 border border-yellow-400/40 px-2 py-0.5 rounded">Pending</span>}
                </div>
                <p className="text-sm text-[#D1C7C9]">"{r.comment}"</p>
                <p className="text-xs text-[#D1C7C9]/50 mt-2">{new Date(r.created_at).toLocaleString()}</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => toggle(r.id, "is_approved", !r.is_approved)}
                  className={`px-3 py-1.5 rounded text-xs uppercase tracking-widest ${r.is_approved ? "border border-yellow-400/40 text-yellow-400" : "border border-green-400/40 text-green-400"}`}
                  data-testid={`approve-${r.id}`}
                >
                  {r.is_approved ? <><EyeOff size={12} className="inline" /> Unapprove</> : <><CheckCircle size={12} className="inline" /> Approve</>}
                </button>
                <button onClick={() => del(r.id)} className="text-red-400 px-3 py-1.5" data-testid={`delete-review-${r.id}`}><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <p className="text-[#D1C7C9]">No reviews yet.</p>}
      </div>
    </div>
  );
}
